<template>
  <div>
    <span class="key">
      <slot name="k">{{ k }}</slot>
    </span>
    <strong class="value text-primary">
      <slot name="v">{{ v }}</slot>
    </strong>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  k?: string;
  v?: string;
}>();
</script>

<style scoped>
div {
  min-width: 0;
}
.key {
  font-size: 18px;
}
.value {
  font-size: 22px;
}
span {
  display: block;
}
@media (max-width: 850px) {
  .key, .value {
    text-align: center;
  }
  .value {
    font-size: 20px;
  }
}
</style>